import * as React from "react";
import { useAppContext } from "../../Contexts/AppContext";
import Portal from "../Portal";

export interface IInfo {
    text?: string;
    xy?: number[];
}

export const Info = (): JSX.Element => {
    const { info, setInfo } = useAppContext();

    const position = info &&
        info.xy &&
        info.xy.length && {
            transform: "translate(" + Math.round(info.xy[0] - 10) + "px, " + Math.round(info.xy[1]) + "px)"
        };

    return info && info.text ? (
        <Portal id={"info-portal"}>
            <div className="info-node" onClick={() => setInfo(null)}>
                <div className="info-window" style={position}>
                    <div className="info-shadow">
                        <div className="info-content">{info.text}</div>
                    </div>
                </div>
            </div>
        </Portal>
    ) : null;
};
